import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  MenuItem,
  Button,
  Grid,
  Box,
  Snackbar,
  Alert,
  Autocomplete
} from "@mui/material";
import api, { investorApi, salesApi } from "../../api/api";
import { useLocation } from "react-router-dom";

const SaleUpdatePage = () => {
  const location = useLocation();
  const rowData = location.state?.rowData || {};
  console.log(rowData);
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    PropertyType:rowData.PropertyType,
    propertyId:rowData.propertyId ?? rowData.id,
    userId: rowData.userId,
    salePrice: "",
    status: "Initiated",
    saleDate: "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

useEffect(() => {
  const fetchData = async () => {
    try {
      const usersRes = await investorApi.getAllUsers();

      const mappedUsers = usersRes.data.map((item) => ({
        id: item.ID,
        username: item.Username,
        mobilenumber: item.Mobilenumber
      }));

      setUsers(mappedUsers);

      // 🔥 Preselect buyer from SalePage
      if (rowData.userId) {
        const selectedUser = mappedUsers.find(
          (u) => u.id === rowData.userId
        );

        if (selectedUser) {
          setFormData((prev) => ({
            ...prev,
            userId: selectedUser.id
          }));
        }
      }

    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  fetchData();
}, [rowData.userId]);
  // console.log(users);
  
  


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // console.log(formData);
      const fd=new FormData();
      fd.append("PropertyType",rowData.PropertyType);
      if(rowData.PropertyType === 3){
        fd.append("propertyId",rowData.ApartmentId ?? rowData.id);
      }
      else{
        fd.append("propertyId",rowData.PropertyId ?? rowData.id);
      }
      fd.append("userId",formData.userId);
      fd.append("salePrice",formData.salePrice);
      fd.append("saleDate",formData.saleDate);
      fd.append("status",formData.status);
      fd.forEach((value, key) => {
  console.log(`${key}:`, value);
});
      const response = await salesApi.updateSale(fd);
      if(response.status === 200){
      setSnackbarMessage("Sale updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      }
    } catch (error) {
      console.error(error);
      setSnackbarMessage("Failed to update sale. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ p: 4, boxShadow: 3, borderRadius: 2, bgcolor: "background.paper" }}>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <Typography variant="h4" gutterBottom align="center" color="primary">
          Update Sale
        </Typography>

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
{rowData && parseInt(rowData.PropertyType) === 1 && (
  <Grid item xs={12}>
    <TextField
      label="Project Name"
      name="project name"
      value={rowData.project_name || ''}
      fullWidth
      required
    />
  </Grid>
)}
{rowData && rowData.PropertyType === 3 && (
  <Grid item xs={12}>
    <TextField 
    label= "Apartment Name"
    name ="ApartmentName"
    value={rowData.ApartmentName || ''}
    fullWidth
    required
    />
    </Grid>
)}
              <Grid item xs={12}>
                <TextField
               
                  label="Property Name"
                  name="Property Name"
                  value={rowData.PropertyName}
                  fullWidth
                  required
                >
                 
                </TextField>
              </Grid>
            

            {/* User dropdown */}
            <Grid item xs={12}>
           <Autocomplete
  options={[
    { id: 0, username: 'N/A', mobilenumber: '' },
    ...users
  ]}
  getOptionLabel={(option) =>
    option.username
      ? `${option.username}${option.mobilenumber ? ' - ' + option.mobilenumber : ''}`
      : ''
  }

  // ✅ Prefill existing buyer OR N/A
  value={
    users.find((user) => user.id === formData.userId) ||
    { id: 0, username: 'N/A', mobilenumber: '' }
  }

  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      userId: newValue ? newValue.id : 0,
    }));
  }}

  isOptionEqualToValue={(option, value) =>
    option?.id === value?.id
  }

  renderInput={(params) => (
    <TextField
      {...params}
      label="Buyer Name"
      fullWidth
      size="small"
      required
    />
  )}
/>
            </Grid>

            {/* Sale Price */}
            <Grid item xs={12}>
              <TextField
                label="Sale Price"
                type="number"
                name="salePrice"
                value={formData.salePrice}
                onChange={handleChange}
                placeholder="Enter Sale Price"
                fullWidth
                required
              />
            </Grid>

            {/* Status */}
            <Grid item xs={12}>
              <TextField
                select
                label="Status"
                name="status"
                value={formData.status}
                onChange={handleChange}
                fullWidth
              >
               
                <MenuItem value="InProgress">InProgress</MenuItem>
                <MenuItem value="Completed">Completed</MenuItem>
                 <MenuItem value="Rejected">Rejected</MenuItem>
              </TextField>
            </Grid>

            {/* Sale Date */}
            <Grid item xs={12}>
              <TextField
                label="Sale Date"
                type="date"
                name="saleDate"
                value={formData.saleDate}
                onChange={handleChange}
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
                 inputProps={{
    max: new Date().toISOString().split("T")[0], }}
              />
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                Update Sale
              </Button>
            </Grid>

          </Grid>
        </form>
      </Box>
    </Container>
  );
};

export default SaleUpdatePage;
